import { jsx as _jsx } from "react/jsx-runtime";
import { createFetchedData, getFetchedDataPayload, getShowtimeIdsForQueryOnBusinessDate, getShowtimesByIds, getSiteById, LoadingState, loadShowtimesForBusinessDate, logger } from '@vista/omnichannel-components-domain';
import { observer } from 'mobx-react';
import { useContext, useEffect, useState } from 'react';
import { useI18n } from '../../../context/occ/hooks/use-i18n';
import { getDropdownOptionsForShowtimes as getDropdownOptionsForShowtimesUtil, ShowtimeDropdownOptionTemplate, ShowtimePreviewDropdownOptionTemplate } from '../../../subcomponents/form/input/dropdown/option-templates/showtime';
import { QuickNavigatorContextInstance } from '../types/context';
import { DropdownType, QuickNavigatorDropdown } from './dropdown';
export const QuickNavigatorShowtimeDropdown = observer(() => {
    const i18n = useI18n();
    const { displayText, config, state, assets } = useContext(QuickNavigatorContextInstance);
    const { enableSearch } = config.showtimes;
    const selectedSite = state.dropdownSelections.site;
    const selectedFilm = state.dropdownSelections.film;
    const selectedBusinessDate = state.dropdownSelections.screeningDate;
    const [messageType, setMessageType] = useState();
    const [isLoading, setIsLoading] = useState(false);
    const showtimeIdsForQuery = selectedSite && selectedFilm && selectedBusinessDate
        ? getShowtimeIdsForQueryOnBusinessDate({
            siteIds: [selectedSite],
            filmIds: [selectedFilm]
        }, selectedBusinessDate)
        : createFetchedData(LoadingState.NotLoaded);
    const showtimeIds = getFetchedDataPayload(showtimeIdsForQuery) || [];
    const dropdownOptions = getDropdownOptionsForShowtimes(showtimeIds, displayText, config.showtimes.showScreenName, i18n, selectedSite);
    useEffect(() => {
        (async () => {
            if (!selectedBusinessDate || !selectedSite || !selectedFilm)
                return;
            setIsLoading(true);
            try {
                await loadShowtimesForBusinessDate({ siteIds: [selectedSite], filmIds: [selectedFilm] }, selectedBusinessDate);
                setMessageType(undefined);
            }
            catch (error) {
                logger.error(error);
                setMessageType(QuickNavigatorShowtimeDropdownMessageType.FailedToLoadShowtimes);
            }
            finally {
                setIsLoading(false);
            }
        })();
    }, [selectedBusinessDate, selectedFilm, selectedSite]);
    const messageProps = getQuickNavigatorShowtimeDropdownMessageProps(messageType, assets, displayText);
    return (_jsx(QuickNavigatorDropdown, Object.assign({}, messageProps, { type: DropdownType.Showtime, options: dropdownOptions, loading: isLoading, disabled: showtimeIdsForQuery.loadingState === LoadingState.NotLoaded, enableSearch: enableSearch, placeholder: displayText.showtimeDropdownPlaceholder, label: displayText.showtimeDropdownLabel, modal: Object.assign(Object.assign({}, messageProps === null || messageProps === void 0 ? void 0 : messageProps.modal), { displayAsModalOnMobile: config.showtimes.displayAsModalOnMobile, heading: displayText.showtimeModalHeading, searchInputPlaceholder: displayText.showtimeModalSearchInputPlaceholder, noSearchResultsFoundMessage: displayText.noShowtimeSearchResultsFoundModalMessage, noSearchResultsFoundIconName: assets.noShowtimesFoundModalIconName }), optionTemplate: ShowtimeDropdownOptionTemplate, optionPreviewTemplate: ShowtimePreviewDropdownOptionTemplate, noSearchResultsFoundMessage: displayText.noShowtimesFoundErrorMessage })));
});
QuickNavigatorShowtimeDropdown.displayName = 'QuickNavigatorShowtimesDropdown';
const getDropdownOptionsForShowtimes = (showtimeIds, displayText, showScreenName, i18n, selectedSiteId) => {
    const site = selectedSiteId ? getSiteById(selectedSiteId) : undefined;
    const showtimes = getShowtimesByIds(showtimeIds);
    const config = {
        showtimeFormat: displayText.showtimeFormat,
        ianaTimeZoneName: site === null || site === void 0 ? void 0 : site.ianaTimeZoneName,
        showScreenName
    };
    return getDropdownOptionsForShowtimesUtil(showtimes, i18n, config);
};
var QuickNavigatorShowtimeDropdownMessageType;
(function (QuickNavigatorShowtimeDropdownMessageType) {
    QuickNavigatorShowtimeDropdownMessageType["FailedToLoadShowtimes"] = "FailedToLoadShowtimes";
})(QuickNavigatorShowtimeDropdownMessageType || (QuickNavigatorShowtimeDropdownMessageType = {}));
const getQuickNavigatorShowtimeDropdownMessageProps = (messageType, assets, displayText) => {
    switch (messageType) {
        case QuickNavigatorShowtimeDropdownMessageType.FailedToLoadShowtimes:
            return {
                errorMessageHelpText: displayText.failedToLoadShowtimesErrorMessage,
                modal: {
                    errorTitle: displayText.failedToLoadShowtimesModalErrorTitle,
                    errorMessage: displayText.failedToLoadShowtimesModalErrorMessage,
                    errorIconName: assets.failedToLoadShowtimesModalErrorIconName
                }
            };
        default:
            return undefined;
    }
};
